import { t as e } from "./createLucideIcon-CJLgHpqc.js";
var t = e("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]);
//#endregion
export { t };

//# sourceMappingURL=check-hnLqiRGn.js.map